export const buildEditWorkOrderFormData = (workOrder) => ({
  id: workOrder.id,
  propertyId: workOrder.property?.id,
  description: workOrder.description,
  isUrgent: workOrder.isUrgent,
  isAfterHours: workOrder.isAfterHours,
  workOrderType: workOrder.workOrderType,
  photos: workOrder.photos || [],
  assignedToId: workOrder.assignedToId || '',
  assignedTeamId: workOrder.assignedTeamId || '',
  assignedRoles: workOrder.assignedRoles || [],
  dueDate: workOrder.dueDate || '',
  customFlags: workOrder.customFlags || [],
  property: workOrder.property,
});
